import React, { Component } from 'react';
import {observer} from "mobx-react"
import EntreeStore from "../EntreeStore"
import axios from "axios"
import { HashRouter as Router, Route, Link } from "react-router-dom";

@observer
class Dashboard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
    };
    EntreeStore.loadPieces()
  }
  componentDidMount(){
  }
  render() {
    if(EntreeStore.loaded){

      return(
        <div>
            <h1 className="center">Etat des lieux d'entrée</h1>
            <div className="row">
              {EntreeStore.pieces.map((piece)=>(
                  <Link key={piece.id} to={"/expertise/piece/"+piece.id+"/"+piece.typedepiece.titre}>
                  <div  style={blocks} className={EntreeStore.dones.includes(piece.id) ? "green" : "orange"}>
                    <h2 className="center white-text">{piece.typedepiece.titre}</h2>
                    <p className="center white-text">pièce numéro {piece.numero || "Non défini"}</p>
                  </div>
                  </Link>
                ))}
            </div>
        </div>
        )
    }else{
     return (
        <div>
        Chargement en cours
        </div>
      );
   }
  }
}
const blocks = {
  display: "inline-block",
  width: "21vw",
  marginLeft: "1.5vw",
  marginRight: "1.5vw",
  marginBottom: "1.5vw"

}



export default Dashboard
